export default __webpack_public_path__ + "static/media/Icon_ParaPass@3x.aaacb17c.png";